import style from './Field.module.scss';

interface FieldsRowProps {
    children: React.ReactNode | React.ReactNode[];
}

export function FieldsRow({ children }: FieldsRowProps): React.ReactElement<any> {
    return <div className={style.fieldsRow}>{children}</div>;
}
